/* eslint no-console: 0 */
/* eslint no-param-reassign: 0 */
/* eslint no-shadow: 0 */
import * as types from '../mutation-types';
import CallCenterAPI from 'dashboard/api/callcenter';

const state = {
  record: {},
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isUpdating: false,
  },
  callrecords: [],
  totalCount: 0,
};

export const getters = {
  getCallcenter($state) {
    return $state.record;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getRecords($state) {
    return $state.callrecords;
  },
  getRecordsTotal($state) {
    return $state.totalCount;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_CALLCENTER_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await CallCenterAPI.get();
      commit(types.default.CALLCENTER_DATA, response.data);
      commit(types.default.SET_CALLCENTER_UI_FLAG, {
        isFetchingItem: false,
      });
    } catch (error) {
      commit(types.default.SET_CALLCENTER_UI_FLAG, {
        isFetchingItem: false,
      });
    }
  },
  update: async ({ commit }, updateObj) => {
    commit(types.default.SET_CALLCENTER_UI_FLAG, { isUpdating: true });
    try {
      await CallCenterAPI.update('1', updateObj);
      commit(types.default.SET_CALLCENTER_UI_FLAG, { isUpdating: false });
    } catch (error) {
      commit(types.default.SET_CALLCENTER_UI_FLAG, { isUpdating: false });
      throw new Error(error);
    }
  },
  records: async ({ commit }, obj) => {
    try {
      const response = await CallCenterAPI.records(obj);
      commit('CALLCENTER_RECORDS', response.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  dial: async ({ rootState }, obj) => {
    try {
      console.log(rootState);
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.dial(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  hangup: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.hangup(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  setDnd: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.setDnd(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  keepCall: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.keepCall(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  transfer: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.transfer(url, obj);
      return response;
    } catch (error) {
      throw new Error();
    }
  },
  conference: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.conference(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  phoneLocation: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.phoneLocation(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  getdnd: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.getdnd(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  getCdrRecords: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.getCdrRecords(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  getExtensionStatus: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.getExtensionStatus(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  canhelp: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.getExtensionStatus(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
  getDst: async ({ rootState }, obj) => {
    try {
      const url = rootState.accounts.currentUser.callcenter.url;
      const response = await CallCenterAPI.getDestination(url, obj);
      return response;
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.default.SET_CALLCENTER_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.CALLCENTER_DATA]($state, data) {
    $state.record = data;
  },
  CALLCENTER_RECORDS($state, { list = [], total = 0 }) {
    $state.callrecords = list;
    $state.totalCount = total;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
